module.exports = __webpack_public_path__ + "img/logo-relation.c00f2bdd.svg";